<template>
  <div class="question">
    <ul v-if="commonQuestionList && commonQuestionList.length > 0">
      <li v-for="item in commonQuestionList" :key="item._id">
        <router-link :to="{ name:'QuestionDetail', query: { id: item._id, type: 'quesion' }}">
          {{item.remark ? '• ' + item.remark : ''}}
        </router-link>
      </li>
    </ul>
    <div class="empty" v-if="commonQuestionList && commonQuestionList.length === 0">暂无内容</div>

    <!-- 分页 -->
    <el-pagination
      v-if="total > pageSize"
      background
      class="page"
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
      :current-page="pageNum" 
      :page-sizes="[10, 20, 30, 40]" 
      :page-size="pageSize" 
      layout="sizes, total, prev, pager, next, jumper" 
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'CommonQuestion',
  data() {
    return {
      commonQuestionList: [],//常见问题列表
      pageSize:10,
      pageNum:1,
      total:0,
    };
  },
  computed: {
    ...mapState({
      currentClient: state=>state.User.currentClient,
      productionId: state=>state.ProductManager.productionId,
    })
  },
  watch:{
    productionId:{
      handler(val){
        if(val){
          // 常见问题
          this.getQuestionClientInfo();
        }
      },
      immediate:true
    }
  },
  mounted() {},

  methods: {
    ...mapActions(['productionClientInfo', 'questionClientInfo']),
    
    handleSizeChange(size) {
      this.pageSize = size;
      this.getQuestionClientInfo();
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getQuestionClientInfo();
    },
      //获取常见问题
    getQuestionClientInfo(){
      this.questionClientInfo({
        "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        "productionId":this.productionId, //关联的产品类型
        "questionTypeid":"", //问题类型
        "commonQuestion": true, //是否常见问题
        p: this.pageNum,
        s: this.pageSize   
      }).then(res => {
        this.commonQuestionList = res.items;
        this.total = res.total;
      })
    },
  },
};
</script>

<style lang="sass" rel="stylesheet/scss"  scoped>
.question {
  ul {
    margin: 10px auto 0;
    min-height: 300px;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    li {
      a{
        display: flex;
        line-height: 36px;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      a:hover{
        color: #1daef8;
        text-decoration: none;
      }
    }
  }
  ul::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .page{
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    text-align: center;
    background: #fff;
  }

  .empty{
    text-align: center;
    margin-top: 20px;
    color: #999;
    cursor: default;
  }
}
</style>


// WEBPACK FOOTER //
// commonQuestion.vue?a05342c2